import IconBuilderCategory from "lib/components/typedIcons/IconBuilderCategory";
import { useUserContext } from "lib/state/UserContextProvider";
import getUserFullName from "lib/utils/userName";
import cx from "ui/cx";
import styles from "./BuilderName.module.scss";

export default function BuilderName() {
  const { hasPermission, user, builder } = useUserContext();
  const userName = getUserFullName(user);
  const builderName = builder ? builder.companyName : "";
  const builderCategory = builder ? builder.category : "";
  const name = hasPermission("VIEW_BUILDER_INFO") ? builderName : userName;

  if (!name && !["TESTING", "TRAINING"].includes(builderCategory)) {
    return null;
  }

  return (
    <div
      className={cx({
        styles,
        wrapper: true,
        testing: builderCategory === "TESTING",
        training: builderCategory === "TRAINING",
      })}
    >
      {builderCategory === "TESTING" && (
        <span className={styles.icon}>
          <IconBuilderCategory category="TESTING" />
        </span>
      )}
      {builderCategory === "TRAINING" && (
        <span className={styles.icon}>
          <IconBuilderCategory category="TRAINING" size={16} />
        </span>
      )}
      <div className={cx(!name && styles.link)}>{name}</div>
    </div>
  );
}
